import React, { FC } from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import { ExploreTopFiltersContainer } from 'src/features/common/explore/containers/explore-top-filters-container';
import { NftsExploreContainer } from 'src/features/common/explore/containers/nfts-explore-container';
import { CollectionDetailsContainer } from 'src/features/white-labels/ocean/collection/containers/collection-details-container';
import { ExploreContentLayout } from 'src/features/white-labels/ocean/explore/components/explore-content-layout';
import { FilterButton } from 'src/features/white-labels/ocean/explore/components/filter-button';
import { ExploreFilterContainer } from 'src/features/white-labels/ocean/explore/containers/explore-filter-container';
import { PageLayout } from 'src/ui/common/layouts/page-layout';
import { Visible } from 'src/ui/common/layouts/visible';
import { SimpleTabs } from 'src/ui/white-labels/ocean/molecules/simple-tabs';

interface IProps {
    title: string;
    description: string;
    originalUrl: string | undefined;
    id: string;
    isFiltersApplied: boolean;
    clearFilters: () => void;
    sideBarOpened: boolean;
    toggleSideBar: () => void;
    tabs: { tabId: string; tab: string }[];
    // eslint-disable-next-line no-undef
    emptyPlaceholder: ({ itemsGridConfig }: any) => JSX.Element;
}

export const CollectionPage: FC<IProps> = ({
    title,
    description,
    originalUrl,
    id,
    isFiltersApplied,
    clearFilters,
    sideBarOpened,
    toggleSideBar,
    tabs,
    emptyPlaceholder,
}) => (
    <>
        <PageMeta title={title} description={description} ogImage={originalUrl} />
        <PageLayout fullWidth>
            <CollectionDetailsContainer collectionId={id as string} />
            <SimpleTabs initialTabId="items">
                <ExploreContentLayout>
                    <ExploreContentLayout.TopPanel>
                        <Visible view={['desktop', 'laptop']}>
                            <FilterButton
                                showClearBtn={isFiltersApplied}
                                onClear={clearFilters}
                                opened={sideBarOpened}
                                onToggle={toggleSideBar}
                            />
                        </Visible>
                        <SimpleTabs.TabItems tabItems={tabs} />
                    </ExploreContentLayout.TopPanel>
                    <ExploreContentLayout.Content>
                        <ExploreContentLayout.SideBar opened={sideBarOpened}>
                            <ExploreFilterContainer />
                        </ExploreContentLayout.SideBar>
                        <ExploreContentLayout.ExploreContent>
                            <SimpleTabs.Content tabId="items">
                                <ExploreTopFiltersContainer />
                                <NftsExploreContainer
                                    sideBarOpened={sideBarOpened}
                                    emptyPlaceholder={emptyPlaceholder}
                                />
                            </SimpleTabs.Content>
                        </ExploreContentLayout.ExploreContent>
                    </ExploreContentLayout.Content>
                </ExploreContentLayout>
            </SimpleTabs>
        </PageLayout>
    </>
);
